var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row fix-height-not-mobile"},[_c('div',{staticClass:"col-sm-2 col-xs-4"},[_c('customer-title')],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5 col-xs-8"},[_c('customer-first-name')],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5 col-xs-12"},[_c('customer-last-name')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }